<template>
    <div class="account-warpper">
        <div class="bg-white ">
            <el-form :model="teamForm" :rules="rules" ref="teamForm" label-width="100px">
                <el-form-item label="社区：" prop="project" v-if="user.power === 3">
                    <el-select v-model="teamForm.project" placeholder="请选择社区" style="width: 100%;" @change="projectChange">
                        <el-option
                            v-for="item in projectList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="队伍名称" prop="name">
                    <el-input v-model="teamForm.name" placeholder="请输入队伍名称"></el-input>
                </el-form-item>
                <el-form-item label="队伍类型" prop="type">
                    <el-select v-model="teamForm.type" placeholder="请选择队伍类型" style="width: 100%;" @change="setType">
                        <el-option
                            :label="'社区服务队'" :value="1">
                        </el-option>
                        <el-option
                            :label="'街道服务队'" :value="2">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="队长" prop="guanjia_id">
                    <el-select v-model="teamForm.guanjia_id" placeholder="请选择队长" style="width: 100%;">
                        <el-option
                            v-for="item in guanjia"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="队员" prop="admin_id_str">
                    <el-select v-model="teamForm.admin_id_str" multiple filterable placeholder="请选择队员" style="width: 100%;">
                        <el-option
                            v-for="item in admin"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="服务小区" prop="xiaoqu_id_str1" v-if="teamForm.type === 1">
                    <el-select v-model="teamForm.xiaoqu_id_str1" filterable placeholder="请选择服务小区" style="width: 100%;">
                        <el-option
                            v-for="item in xiaoqu"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="服务小区" prop="xiaoqu_id_str2" v-if="teamForm.type === 2">
                    <el-select v-model="teamForm.xiaoqu_id_str2" multiple filterable placeholder="请选择服务小区" style="width: 100%;">
                        <el-option
                            v-for="item in xiaoqu"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" type="primary" @click="submitForm('teamForm')">保存</el-button>
                </el-form-item>


            </el-form>

        </div>
    </div>
</template>

<script>

import {getXiangMuList, getXiaoQuList} from "@/api/common";
import {addNewServiceTeam, getServiceTeamDetail, getWuyeguanjiaList} from "@/api/weilao";

export default {
    name: "account",
    data() {
        return {
            projectList: [],
            xiaoqu: [],
            guanjia: [],
            admin: [],
            teamForm: {
                project: '',
                name: '',
                type: '',
                xiaoqu_id_str1: '',
                xiaoqu_id_str2: [],
                guanjia_id: '',
                admin_id_str: [],
            },
            rules: {
                project: [{required: true, message: '请选择社区', trigger: 'blur'}],
                name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                type: [{required: true, message: '请选择队伍类型', trigger: 'change'}],
                xiaoqu_id_str1: [{required: true, message: '请选择服务小区', trigger: 'change'}],
                xiaoqu_id_str2: [{type: 'array', required: true, message: '请选择服务小区', trigger: 'change'}],
                guanjia_id: [{required: true, message: '请选择队长', trigger: 'change'}],
                admin_id_str: [{type: 'array', required: true, message: '请选择队员', trigger: 'change'}],
            }
        }
    },
    created() {
        this.$emit("setIndex", '/home/team-list', "双暖为老 / 双暖服务队编辑", true);
        if (Number(this.$route.params.id)) this.getDetail()
        this.getXiangMuList()
        this.getWuyeguanjiaList()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    components: {},
    methods: {

        setType() {
            this.teamForm.xiaoqu_id_str1 = ''
            this.teamForm.xiaoqu_id_str2 = []
        },
        //  获取服务队信息
        async getDetail() {
            const res = await getServiceTeamDetail(this.$route.params.id)
            this.teamForm = {
                name: res.data.name,
                project: res.data.xiangmu_id,
                type: res.data.type,
                xiaoqu_id_str1: res.data.type === 1 ? Number(res.data.xiaoqu_id_str) : '',
                xiaoqu_id_str2: res.data.type === 2 ? res.data.xiaoqu_id_str.split(',').map(Number) : [],
                guanjia_id: res.data.guanjia_id,
                admin_id_str: res.data.admin_id_str.split(',').map(Number),
            }
            this.getXiaoQuList()
        },
        //  获取当前人员下的小区
        async getXiangMuList() {
            const project = await getXiangMuList()
            this.projectList = project.data
            if (this.user.power !== 3 && !Number(this.$route.params.id || 0)) {
                this.teamForm.project = project.data[0].id
                this.getXiaoQuList()
            }
        },
        //  获取当前人员下的小区
        async getXiaoQuList() {
            const res = await getXiaoQuList(this.teamForm.project)
            this.xiaoqu = res.data
        },
        projectChange() {
            this.xiaoqu = []
            this.teamForm.xiaoqu_id_str1 = ''
            this.teamForm.xiaoqu_id_str2 = []
            this.getXiaoQuList()
        },
        async getWuyeguanjiaList() {
            const res = await getWuyeguanjiaList('', '', 6, 1, 100000)
            this.guanjia = res.data
            const data = await getWuyeguanjiaList('', '', 8, 1, 100000)
            this.admin = data.data
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await addNewServiceTeam(
                this.teamForm.name,
                this.teamForm.project,
                this.teamForm.type,
                this.teamForm.type === 1 ? this.teamForm.xiaoqu_id_str1 : this.teamForm.xiaoqu_id_str2.join(','),
                this.teamForm.guanjia_id,
                this.teamForm.admin_id_str.join(','),
                Number(this.$route.params.id) ? this.$route.params.id : '',
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$router.go(-1)
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">

</style>
